export default __webpack_public_path__ + "static/media/93.bc8d48cb.jpg";